import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
export const GET_EXTERNAL_USER_LIST =
  "GET_EXTERNAL_USER_LIST";

export const service = async (data) => {
  const options: object = {
    url: `/Api/ExternalUser/GetExternalUserList`,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_EXTERNAL_USER_LIST, service, mock);
